// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: iKm2w5zQkVZvuqT51PP4Eo
// Component: fmpSw01Nli

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import TextInput from "../../TextInput"; // plasmic-import: LW1ZHmZtc1I/component
import GenerateButton from "../../GenerateButton"; // plasmic-import: Fs5OtDdX5n/component
import GenericButton from "../../GenericButton"; // plasmic-import: rRlSjYLvCT/component
import LoadingBox from "../../LoadingBox"; // plasmic-import: NfWt_UBWT-/component

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_idea_stats_v_1.module.css"; // plasmic-import: iKm2w5zQkVZvuqT51PP4Eo/projectcss
import sty from "./PlasmicAdPrompt.module.css"; // plasmic-import: fmpSw01Nli/css

import SearchsvgIcon from "./icons/PlasmicIcon__Searchsvg"; // plasmic-import: SvpL0X2s9gW/icon
import ChecksvgIcon from "./icons/PlasmicIcon__Checksvg"; // plasmic-import: SBvHu7dbLxB/icon
import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: UVhfm8Vw8/icon

export type PlasmicAdPrompt__VariantMembers = {};
export type PlasmicAdPrompt__VariantsArgs = {};
type VariantPropType = keyof PlasmicAdPrompt__VariantsArgs;
export const PlasmicAdPrompt__VariantProps = new Array<VariantPropType>();

export type PlasmicAdPrompt__ArgsType = {
  imgSrc?: React.ComponentProps<typeof p.PlasmicImg>["src"];
};
type ArgPropType = keyof PlasmicAdPrompt__ArgsType;
export const PlasmicAdPrompt__ArgProps = new Array<ArgPropType>("imgSrc");

export type PlasmicAdPrompt__OverridesType = {
  root?: p.Flex<"div">;
  h1?: p.Flex<"h1">;
  textInput?: p.Flex<typeof TextInput>;
  generateButton?: p.Flex<typeof GenerateButton>;
  img?: p.Flex<typeof p.PlasmicImg>;
  refreshButton?: p.Flex<typeof GenericButton>;
  selectButton?: p.Flex<typeof GenericButton>;
  text?: p.Flex<"div">;
  loadingBox?: p.Flex<typeof LoadingBox>;
};

export interface DefaultAdPromptProps {
  imgSrc?: React.ComponentProps<typeof p.PlasmicImg>["src"];
  className?: string;
}

const __wrapUserFunction =
  globalThis.__PlasmicWrapUserFunction ?? ((loc, fn) => fn());
const __wrapUserPromise =
  globalThis.__PlasmicWrapUserPromise ??
  (async (loc, promise) => {
    return await promise;
  });

function PlasmicAdPrompt__RenderFunc(props: {
  variants: PlasmicAdPrompt__VariantsArgs;
  args: PlasmicAdPrompt__ArgsType;
  overrides: PlasmicAdPrompt__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const $ctx = ph.useDataEnv?.() || {};
  const args = React.useMemo(
    () =>
      Object.assign(
        {
          imgSrc:
            "https://images.unsplash.com/photo-1655720840699-67e72c0909d1?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1267&q=80" as const
        },
        props.args
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const [$queries, setDollarQueries] = React.useState({});

  const stateSpecs = React.useMemo(
    () => [
      {
        path: "textInput.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => "" as const
      }
    ],
    [$props, $ctx]
  );
  const $state = p.useDollarState(stateSpecs, { $props, $ctx, $queries });

  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          {true ? (
            <div className={classNames(projectcss.all, sty.freeBox__fuC4)}>
              <h1
                data-plasmic-name={"h1"}
                data-plasmic-override={overrides.h1}
                className={classNames(
                  projectcss.all,
                  projectcss.h1,
                  projectcss.__wab_text,
                  sty.h1
                )}
              >
                {"Generate Your Ad Image"}
              </h1>
              {true ? (
                <div className={classNames(projectcss.all, sty.freeBox___1ChN)}>
                  <TextInput
                    data-plasmic-name={"textInput"}
                    data-plasmic-override={overrides.textInput}
                    className={classNames("__wab_instance", sty.textInput)}
                    onChange={(...eventArgs) => {
                      p.generateStateOnChangeProp($state, [
                        "textInput",
                        "value"
                      ])((e => e.target?.value).apply(null, eventArgs));
                    }}
                    startIcon={
                      <SearchsvgIcon
                        className={classNames(projectcss.all, sty.svg___6AxfV)}
                        role={"img"}
                      />
                    }
                    value={
                      p.generateStateValueProp($state, [
                        "textInput",
                        "value"
                      ]) ?? ""
                    }
                  />

                  <GenerateButton
                    data-plasmic-name={"generateButton"}
                    data-plasmic-override={overrides.generateButton}
                    className={classNames("__wab_instance", sty.generateButton)}
                  />
                </div>
              ) : null}
              <p.PlasmicImg
                data-plasmic-name={"img"}
                data-plasmic-override={overrides.img}
                alt={""}
                className={classNames(sty.img)}
                displayHeight={"auto" as const}
                displayMaxHeight={"none" as const}
                displayMaxWidth={"100%" as const}
                displayMinHeight={"0" as const}
                displayMinWidth={"0" as const}
                displayWidth={"100%" as const}
                loading={"lazy" as const}
                src={args.imgSrc}
              />

              {true ? (
                <div
                  className={classNames(projectcss.all, sty.freeBox___2Wc5U)}
                >
                  <GenericButton
                    data-plasmic-name={"refreshButton"}
                    data-plasmic-override={overrides.refreshButton}
                    className={classNames("__wab_instance", sty.refreshButton)}
                  >
                    <IconIcon
                      className={classNames(projectcss.all, sty.svg__hsWLa)}
                      role={"img"}
                    />
                  </GenericButton>
                  <GenericButton
                    data-plasmic-name={"selectButton"}
                    data-plasmic-override={overrides.selectButton}
                    className={classNames("__wab_instance", sty.selectButton)}
                  >
                    <div
                      data-plasmic-name={"text"}
                      data-plasmic-override={overrides.text}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text
                      )}
                    >
                      {"Select"}
                    </div>
                  </GenericButton>
                </div>
              ) : null}
            </div>
          ) : null}
          {true ? (
            <LoadingBox
              data-plasmic-name={"loadingBox"}
              data-plasmic-override={overrides.loadingBox}
              className={classNames("__wab_instance", sty.loadingBox)}
            />
          ) : null}
        </div>
      </div>
    </React.Fragment>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "h1",
    "textInput",
    "generateButton",
    "img",
    "refreshButton",
    "selectButton",
    "text",
    "loadingBox"
  ],
  h1: ["h1"],
  textInput: ["textInput"],
  generateButton: ["generateButton"],
  img: ["img"],
  refreshButton: ["refreshButton"],
  selectButton: ["selectButton", "text"],
  text: ["text"],
  loadingBox: ["loadingBox"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  h1: "h1";
  textInput: typeof TextInput;
  generateButton: typeof GenerateButton;
  img: typeof p.PlasmicImg;
  refreshButton: typeof GenericButton;
  selectButton: typeof GenericButton;
  text: "div";
  loadingBox: typeof LoadingBox;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicAdPrompt__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicAdPrompt__VariantsArgs;
    args?: PlasmicAdPrompt__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicAdPrompt__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicAdPrompt__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicAdPrompt__ArgProps,
          internalVariantPropNames: PlasmicAdPrompt__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicAdPrompt__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicAdPrompt";
  } else {
    func.displayName = `PlasmicAdPrompt.${nodeName}`;
  }
  return func;
}

export const PlasmicAdPrompt = Object.assign(
  // Top-level PlasmicAdPrompt renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    h1: makeNodeComponent("h1"),
    textInput: makeNodeComponent("textInput"),
    generateButton: makeNodeComponent("generateButton"),
    img: makeNodeComponent("img"),
    refreshButton: makeNodeComponent("refreshButton"),
    selectButton: makeNodeComponent("selectButton"),
    text: makeNodeComponent("text"),
    loadingBox: makeNodeComponent("loadingBox"),

    // Metadata about props expected for PlasmicAdPrompt
    internalVariantProps: PlasmicAdPrompt__VariantProps,
    internalArgProps: PlasmicAdPrompt__ArgProps,

    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicAdPrompt;
/* prettier-ignore-end */
